// extracted by mini-css-extract-plugin
module.exports = {"tapePlayerHolder":"reelToReel_tapePlayerHolder__VnMUu","svg":"reelToReel_svg__j2x0C"};